var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"26","height":"27","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M13.404 12.861h11.744v1.294H13.404v12.28h-1.342v-12.28H.782v-1.294h11.28V.557h1.342V12.86z","fill":"#fff"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }